module.exports = __webpack_public_path__ + "img/ow-social.6e0cb51f.jpg";